<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :total-count="items.length"
    :server-items-length="items.length"
    hide-default-footer
    dense
  >
    <template #top>
      <v-toolbar flat>
        <v-toolbar-title>
          {{
            shop && shop.name
              ? $t('reservation.today.text.titleWithShop', {
                  shopName: shop.name,
                })
              : $t('reservation.today.text.title')
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn text :to="{ name: 'reservation-today' }" exact="">
            {{ $t('reservation.today.text.shopSelection') }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <small>{{
          $t('reservation.today.text.lastFetchDateTime', {
            date: $options.filters.datetime(lastFetch),
          })
        }}</small>
        <small
          >{{ $t('reservation.today.text.total', { count: totalCount }) }}
        </small>
      </v-container>
    </template>

    <template #item.nameKana="{ item }">
      <span v-if="$i18n.locale === 'ja'">
        {{ item.familyNameKana }}
        {{ item.firstNameKana }}
      </span>
    </template>

    <template #item.createdAt="{ item }">
      {{ item.createdAt | datetime }}
    </template>

    <template #footer>
      <infinite-loading @infinite="infiniteHandler" />
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'
import padStart from 'lodash/padStart'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'ReservingTodayInShop',
  components: {
    InfiniteLoading,
  },
  filters: {
    startTime(item) {
      let { startHour, startMinute } = item
      return `${padStart(startHour, 2, '0')}:${padStart(startMinute, 2, '0')}`
    },
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    idToReserve: {},
    shop: null,
    lastFetch: null,
    totalCount: 0,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t('reservation.today.text.memberNumber'),
          value: 'customerCode',
        },
        ...(this.$i18n.locale === 'ja'
          ? [
              {
                text: this.$t('reservation.today.text.nameKana'),
                value: 'nameKana',
              },
            ]
          : []),
        {
          text: this.$t('reservation.today.text.reservationDate'),
          value: 'date',
        },
        {
          text: this.$t('reservation.today.text.reservationTime'),
          value: 'time',
        },
        {
          text: this.$t('reservation.today.text.reservationRoute'),
          value: 'reservingWayText',
        },
        {
          text: this.$t('reservation.today.text.registeredDateTime'),
          value: 'createdAt',
        },
      ]
    },
    items() {
      let items = Object.values(this.idToReserve)
      items.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
      return items
    },
    params() {
      return {
        shop: this.shopId,
        fromCreated: moment()
          .startOf('day')
          .toISOString(),
        // reservedBy:  6,
        reserveInShop: true,
        active: true,
      }
    },
  },
  created() {
    this.fetchShop()
    this.fetchCount()
  },
  mounted() {
    this._timerId = setInterval(this.fetchLatests, 60 * 1000)
  },
  beforeDestroy() {
    if (this._timerId) clearInterval(this._timerId)
  },
  methods: {
    async fetchShop() {
      this.shop = await this.$api.shops(this.shopId).get()
    },
    async fetchCount() {
      try {
        const count = await this.$api.reservations().count(this.params)
        this.totalCount = count
      } catch (err) {
        this.$toast.error(this.$t('toast.message.reservationCountFetchFailed'))
      }
    },
    async fetchLatests() {
      try {
        let [{ results }, totalCount] = await Promise.all([
          this.$api.reservations().list(this.params),
          this.$api.reservations().count(this.params),
        ])
        this.totalCount = totalCount
        results.forEach(x => {
          this.$set(this.idToReserve, x.id, x)
        })
        this.lastFetch = moment().toISOString()
      } catch (err) {
        console.error(err)
        this.$toast.error(this.$t('toast.message.reservationDataFetchFailed'))
      }
    },
    async infiniteHandler($state) {
      try {
        let { results, next } = await (this.next
          ? this.$api.http.get(this.next)
          : this.$api.reservations().list(this.params))
        results.forEach(x => {
          this.$set(this.idToReserve, x.id, x)
        })
        this.next = next
        if (results.length > 0) $state.loaded()
        if (!next) $state.complete()
      } catch (err) {
        console.error(err)
        $state.error()
      }
    },
  },
  metaInfo() {
    return { title: this.$t('reservation.today.text.title') }
  },
}
</script>
